var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useImperativeHandle, useRef } from 'react';
import _merge from 'lodash.merge';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import { createEChartsOptionFromChildren } from './utils';
import './theme/rsuite_light';
import { EChartsContext } from './constants';
const styles = {
    blockCenter: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    loaderWrap: {
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)'
    }
};
const defaultOption = {
    grid: {
        containLabel: true
    }
};
// ECharts with empty message and loading
function ECharts(_a, ref) {
    var { height = 300, locale = {
        emptyMessage: 'No data found',
        loading: 'Loading...'
    }, option = {}, children } = _a, props = __rest(_a, ["height", "locale", "option", "children"]);
    const echartsRef = useRef();
    useImperativeHandle(ref, () => echartsRef.current);
    const context = useContext(EChartsContext);
    /**
     * option 覆盖优先级
     * 1. defaultOption 为底
     * 2. props.option
     * 3. state.option (components 的 props)
     */
    function getEChartsOption() {
        return _merge({}, defaultOption, option, createEChartsOptionFromChildren(children, context));
    }
    /**
     * 判断 option 是否没有数据，
     * 用于显示数据为空的 placeholder
     */
    function isDataEmpty(option) {
        if (option.dataset) {
            return isDatasetEmpty(option);
        }
        return isSeriesEmpty(option);
    }
    /**
     * 进入此方法时一定存在 option.dataset
     */
    function isDatasetEmpty(option) {
        if (!option.dataset.source) {
            return true;
        }
        if (Array.isArray(option.dataset.source)) {
            return option.dataset.source.length < 1;
        }
        return Object.getOwnPropertyNames(option.dataset.source).length < 1;
    }
    function isSeriesEmpty(option) {
        return !option.series ||
            option.series.reduce((empty, serie) => empty && (!serie.data || serie.data.length < 1), true);
    }
    function renderEmptyMessage() {
        return (React.createElement("div", { className: "rs-echarts-body-info", style: styles.blockCenter }, locale.emptyMessage));
    }
    function renderLoader() {
        return (React.createElement("div", { className: "rs-echarts-loader-wrap", style: Object.assign(Object.assign({}, styles.blockCenter), styles.loaderWrap) }, locale.loading));
    }
    function onChartReady(echarts) {
        echartsRef.current = echarts;
    }
    const { className, style, loading } = props, echartsForReactProps = __rest(props, ["className", "style", "loading"]);
    const echartsOption = children ? getEChartsOption() : option;
    const dataEmpty = isDataEmpty(echartsOption);
    return (React.createElement("div", { className: `rs-echarts ${className || ''}`, style: Object.assign({ position: 'relative', height }, style) },
        !loading && dataEmpty && renderEmptyMessage(),
        React.createElement(ReactEchartsCore, Object.assign({ echarts: echarts, option: echartsOption, style: { height: '100%', visibility: dataEmpty ? 'hidden' : 'visible' }, onChartReady: onChartReady, notMerge: true, theme: "rsuite_light" }, echartsForReactProps)),
        children,
        loading && renderLoader()));
}
if (process.env.NODE_ENV !== 'production') {
    ECharts.displayName = 'ECharts';
}
export default React.forwardRef(ECharts);
//# sourceMappingURL=ECharts.js.map